import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const state = {
  deviceType: 'isPC',
};

const getters = {
  isMobile: state => state.deviceType === 'isMobile',
  isPad: state => state.deviceType === 'isPad',
  isPC: state => state.deviceType === 'isPC',
}

const mutations = {
  // 设置页面类型
  UPDATE_DEVICE_TYPE(state, value) {
    state.deviceType = value;
    console.log('state.deviceType', state.deviceType);
  },
};

const actions = {

};

const store = new Vuex.Store({
  actions,
  mutations,
  state,
  getters,
});

export default store;
